<div
    class="container-signatures"
    [class.grid-2]="signatures.length === 2"
    [class.grid-3]="signatures.length >= 3">
    @for (signature of signatures; track signature.name + '-' + $index) 
    {
        <div class="signature-item">

            <!-- Tipo de assinatura -->
            <p class="signature-name ra-label-xs bold">{{ signature.type | signatureType }}</p>
            
            <!-- Signature name -->
            <p class="ra-header-s signature-drawing" [style.--signature-font-family]="signature.fontFamily">
                {{ signature.name }}
            </p>

            <!-- Linha de separação -->
            <div class="signature-line"></div>

            <!-- Data de assinatura -->
            <p class="signature-name ra-label-xs">
                <span>{{ signature.name }}</span>
                <span> - </span>
                <span>{{ signature?.signedAt | date:'short' : 'UTC' }}</span>
            </p>
        </div>
    }
</div>
